@import (reference) '../../../../../constants/spacing.module.less';

.card {
  background: var(--white);
  border: 2px solid var(--grey-300);
  border-radius: 8px;
  padding: @space-16;
  width: 850px;

  &:hover {
    border-color: var(--grey-400);
  }

  &.selected {
    border-color: var(--blue-500);
    min-height: 120px;
  }
}

.content {
  flex: 1;
  min-width: 0;
}

.card-header {
  cursor: pointer;
}

.options-toggler {
  border: none;
  background: none;
  padding: 0;
}

.rule-pill {
  align-self: center;
  background-color: var(--grey-200);
  border-radius: 100px;
  flex-shrink: 0;
}
